import { useEffect, useState,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import useConfiguration from "../../hooks/useConfiguration";
import Checkbox from "../common/Checkbox";
import DropDown from "../common/SearchableSelect";
import TextField from "../common/TextField/withLabel";
import { setEducationDetails, updateEducationLevelInMasterData } from "./action";
import { jobOpportunitySelector } from "./selector";
import MultiSelect from "../common/TextField/dropDown";
import { setResetDropdown } from "./slice";

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
    const { masterData, education,selectedOption ,resetDropdown} = useSelector(jobOpportunitySelector);
    const dispatch = useDispatch();
    const [edu, setEdu] = useState(education);
    const config = useConfiguration();
    const educationRef = useRef(null)
    const {newPost,fromTemplate,createTemplate,editJobPost} = selectedOption

    useEffect(() => {
        // console.log("from Spec", masterData?.allJobTypes.length)
        // console.log(masterData?.allJobTypes[0]);
        if (masterData?.allJobTypes.length === 1 && config.baseUrl) {
            dispatch(updateEducationLevelInMasterData(`${config.baseUrl}`, 'type', masterData?.allJobTypes[0]));
        }
    }, [masterData?.allJobTypes.length, config.baseUrl]);
    useEffect(() => {
        dispatch(setEducationDetails(edu));
    }, [edu]);
    useEffect(() => {
        if(newPost|| fromTemplate || createTemplate ){
            if(resetDropdown){
                educationRef.current.resetSelectedValues();
                dispatch(setResetDropdown(false))
            }
        }
    },[newPost,fromTemplate,createTemplate, editJobPost,resetDropdown]) 
    const updateEducationLevel = (data) => {
        if (data.action === 'remove') {
            setEdu({
                ...education,
                level: undefined
            });
        } else {
            setEdu({
                ...education,
                level: data.value
            });
        }
    };

    const updateLanguagesSpoken = (data) => {
        const languagesSpoken = [...education.languageSpoken];
        if (data.target.name === "name") {
            if (data.target.action === 'remove') {
                languagesSpoken[data.index] = undefined;
            } else {
                languagesSpoken[data.index] = {
                    id: data.target.value.id,
                    name: data.target.value.name,
                    mandatory: languagesSpoken[data.index]?.mandatory
                };
            }
        } else if (data.target.name === "mandatory") {
            if (languagesSpoken[data.index] !== undefined) {
                languagesSpoken[data.index] = {
                    id: languagesSpoken[data.index].id,
                    name: languagesSpoken[data.index]?.name,
                    mandatory: data.target.value
                };
            }
        }
        setEdu({
            ...education,
            languageSpoken: languagesSpoken
        });
    };

    const updateOtherLanguagesSpoken = (data) => {
        const otherLanguagesSpoken = [...education.otherLanguagesSpoken];
        otherLanguagesSpoken[data.index] = data.target.value;

        setEdu({
            ...education,
            otherLanguagesSpoken: otherLanguagesSpoken
        });
    };

    const removeLanguagesSpokenRow = (index) => {
        const newLang = [...education.languageSpoken];
        if (newLang.length > 1) {
            newLang.splice(index, 1);
            setEdu({
                ...education,
                languageSpoken: newLang
            });
        }
    };

    const addLanguagesSpokenNewRow = (event) => {
        event.preventDefault();
        const newLanguageSpoken = [...education.languageSpoken];
        newLanguageSpoken.push(undefined);
        setEdu({
            ...education,
            languageSpoken: newLanguageSpoken
        });
    };

    const addOtherLangSpokenNewRow = (event) => {
        event.preventDefault();
        const newOtherLangSpoken = [...education.otherLanguagesSpoken];
        newOtherLangSpoken.push('');
        setEdu({
            ...education,
            otherLanguagesSpoken: newOtherLangSpoken
        });
    };

    const removeOtherLangSpokenRow = (index) => {
        const newLang = [...education.otherLanguagesSpoken];
        newLang.splice(index, 1);
        setEdu({
            ...education,
            otherLanguagesSpoken: newLang
        });
    };

    const languageListBasedOnSelected = (currentVal) => {
        if (currentVal) {
            const removeCurentVal = education?.languageSpoken.filter(item => {
                if (item) {
                    if (item.id !== currentVal.id) {
                        return item
                    }
                }
            });
            if (removeCurentVal?.length) {
                const ids = removeCurentVal.map(item => item.id);
                const filtered = masterData?.allSpokenLanguages?.filter(item => {
                    return !ids.includes(item.id)
                })
                return filtered;
            } else {
                return masterData?.allSpokenLanguages
            }
        } else {
            const removeCurentVal = education?.languageSpoken.map(item => item?.id)
            if (removeCurentVal?.length) {
                const filtered = masterData?.allSpokenLanguages?.filter(item => {
                    return !removeCurentVal.includes(item.id)
                })
                return filtered;
            } else {
                return masterData?.allSpokenLanguages
            }
        }

    }
    const updateLanguageSpokenList = target => {
        let languageSpoken = [...education.languageSpoken];
        if (target.name === "name") {
            if (target.action === 'remove') {
                // languageSpoken = languageSpoken.filter(item => item.id !== target.value.id)
                const indexOfLanguage = languageSpoken?.findIndex(i => i?.id === target.value.id)
                languageSpoken.splice(indexOfLanguage, 1)
                // definedExperience.splice({ id: target.value.id},1)
            } else {
                languageSpoken.push( {
                    id: target.value.id,
                    name: target.value.name,
                    mandatory: false,
                })
            }
    }
    setEdu({
        ...education,
        languageSpoken: languageSpoken
    });
    }
    return (
        <div className="card">
            <div className="col-12">
                <div className="row">
                    <div className="card-header">
                        <h3 class="card-title">Education Info</h3>
                    </div>
                    <div className="card-body">
                        <div className="row">
                                <DropDown name={'level'}
                                    label={'Education Level'}
                                    // star={'*'}
                                    id={'level'}
                                    value={education.level ? [education?.level] : []}
                                    options={masterData?.allEducationLevels} multiple={false}
                                    isClearable = {true}
                                    updateValue={updateEducationLevel} isObject={true}
                                    errors={props.errors ? props.errors['educationLevel'] : []}
                                />
                                
                                <MultiSelect 
                                name={'name'}
                                        label={'Language Spoken'}
                                
                                        // id={'approvalUsers'}
                                        value={ education?.languageSpoken ? education?.languageSpoken:[] }
                                        options={masterData?.allSpokenLanguages}
                                        multiple={true}
                                        updateValue={updateLanguageSpokenList} 
                                        isObject={true}
                                        errors={props.errors ? props.errors['languagesSpoken'] : []}
                                        multiselectRef={educationRef}
                                    />
                                    
                        </div>
                        
                        {/* <div class="row">
                            <div class="col-lg-6 col-md-3">
                                <label class="form-label">Select Spoken Language*</label>
                            </div>

                            <div class="col-lg-2 col-md-3">
                                <label class="form-label">Mandatory</label>
                            </div>
                            <div class="col-lg-1 col-md-3">
                                &nbsp;
                            </div>
                        </div> */}
{/* 
                        <div className="row">
                            {
                                education?.languageSpoken.map((item, index) => (
                                    <div className="row" id="direferences" key={index}>
                                        <div class="col-lg-6 col-md-3">
                                            <DropDown name={'name'}
                                                id={'name'}
                                                value={education?.languageSpoken[index] ? [education?.languageSpoken[index]] : []}
                                                divClass={'col'}
                                                options={languageListBasedOnSelected(education?.languageSpoken[index])} multiple={false}
                                                updateValue={(target) => { updateLanguagesSpoken({ target: target, index: index, subField: 'languageSpoken' }) }} isObject={true}
                                                errors={props.errors?.languagesSpoken ? props.errors['languagesSpoken'][index] : []}
                                            />
                                        </div>
                                        <div class="col-lg-2 col-md-3">
                                            <div className="form-group">
                                                <div className="custom-control custom-checkbox">
                                                    <Checkbox className={'mandatoryMargin'}
                                                        name={"mandatory"}
                                                        checked={education?.languageSpoken[index]?.mandatory}
                                                        updateValue={(target) => { updateLanguagesSpoken({ target: target, index: index, subField: 'languageSpoken' }) }}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-1 col-md-3">
                                            <div className="col-sm deleteIconMargin">
                                                <a name='delete' onClick={(target) => {
                                                    removeLanguagesSpokenRow(index)
                                                }}>
                                                    <i className="fe fe-trash-2"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="row">
                                <div className="col-lg-6 col-md-3">
                                    <a id="btnreferences">
                                        <div className="row">
                                            <div className="col-lg-1 col-md-3">
                                                <i className="icon-2x icon-plus" data-bs-toggle="tooltip" title=""
                                                    data-bs-original-title="icon-plus"
                                                    aria-label="Add References" style={{ "fontSize": "20px" }}
                                                    onClick={addLanguagesSpokenNewRow}>
                                                </i>
                                            </div>
                                            <div className="col-lg-6 col-md-3"
                                                onClick={addLanguagesSpokenNewRow}>Add New
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div> */}
                        <br />
                        {/* <div class="row">
                            <div class="col-lg-3 col-md-3">
                                <label class="form-label">
                                    Other Language Spoken
                                </label>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-6 col-md-3">
                                <label class="form-label">Enter Other Language Spoken</label>
                            </div>
                        </div> */}

                        {/* <div className="row">
                            {
                                education?.otherLanguagesSpoken.map((item, index) => (
                                    <div className="row" id="direferences" key={index}>
                                        <div class="col-lg-6 col-md-3">
                                            <TextField name={'name'}
                                                id={'name'}
                                                divClass={'col'}
                                                value={education?.otherLanguagesSpoken[index]}
                                                updateValue={(target) => { updateOtherLanguagesSpoken({ target: target, index: index, subField: 'otherLanguagesSpoken' }) }} isObject={true}
                                                errors={props.errors ? props.errors['otherLanguagesSpoken'] : []}
                                            /></div>
                                        <div class="col-lg-1 col-md-3">
                                            <div className="col-sm deleteIconMargin">
                                                <a onClick={() => removeOtherLangSpokenRow(index)}>
                                                    <i className="fe fe-trash-2"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                            <div className="row">
                                <div className="col-lg-6 col-md-3">
                                    <a id="btnreferences">
                                        <div className="row">
                                            <div className="col-lg-1 col-md-3">
                                                <i className="icon-2x icon-plus" data-bs-toggle="tooltip" title=""
                                                    data-bs-original-title="icon-plus"
                                                    aria-label="Add References" style={{ "fontSize": "20px" }}
                                                    onClick={addOtherLangSpokenNewRow}>
                                                </i>
                                            </div>
                                            <div className="col-lg-6 col-md-3"
                                                onClick={addOtherLangSpokenNewRow}>Add New
                                            </div>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div >
        </div>
    )
}
